import { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config';
import fetchWithAuth from '../utils/fetchWithAuth';

const useUsers = (currentUser) => {
  const [users, setUsers] = useState([]);
  const [editingUser, setEditingUser] = useState(null);
  const [genericSavedMsg, setgenericSavedMsg] = useState("");
  const [refreshUsers, setRefreshUsers] = useState(false);

  useEffect(() => {
    fetchWithAuth(`${BACKEND_URL}/users`)
      .then(res => res.json())
      .then(data => setUsers(data));
  }, [refreshUsers]);

  const addUser = async (userData) => {
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/users`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...userData,
          createdBy: currentUser?.email || "sistema",
          modifiedBy: currentUser?.email || "sistema"
        })
      });
      const result = await response.json();
      if (!response.ok) {
        setgenericSavedMsg(result.error || "Error al guardar el usuario");
        return { error: result.error };
      }
      setgenericSavedMsg("Usuario guardado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
      setRefreshUsers(r => !r);
      return {};
    } catch (err) {
      setgenericSavedMsg("Error al guardar el usuario");
      return { error: "Error al guardar el usuario" };
    }
  };

  const editUser = async (userData) => {
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/users/${userData.email}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...userData,
          modifiedBy: currentUser?.email || "sistema"
        })
      });
      const result = await response.json();
      if (!response.ok) {
        setgenericSavedMsg(result.error || "Error al editar el usuario");
        return { error: result.error };
      }
      setgenericSavedMsg("Usuario editado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
      setEditingUser(null);
      setRefreshUsers(r => !r);
      return {};
    } catch (err) {
      setgenericSavedMsg("Error al editar el usuario");
      return { error: "Error al editar el usuario" };
    }
  };

  const removeUser = async (email) => {
    if (!window.confirm("¿Estás seguro de que quieres desactivar este usuario?")) return;
    try {
      const response = await fetchWithAuth(`${BACKEND_URL}/users/${email}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ modifiedBy: currentUser?.email || "sistema" })
      });
      if (!response.ok) throw new Error('Error al desactivar el usuario');
      setgenericSavedMsg("Usuario desactivado exitosamente.");
      setTimeout(() => setgenericSavedMsg(""), 3000);
      setRefreshUsers(r => !r);
    } catch (err) {
      setgenericSavedMsg("Error al desactivar el usuario");
    }
  };

  return {
    users,
    addUser,
    editUser,
    removeUser,
    editingUser,
    setEditingUser,
    genericSavedMsg,
    refreshUsers,
    setRefreshUsers
  };
};

export default useUsers;